export default "__VITE_ASSET__BZN4xCIM__"